import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { withInject } from '@piwikpro/platform';

const GlobalAppSettingsLayout = withInject({
  GlobalAppSettings: 'TrackerSettingsCrate.components.GlobalAppSettings',
})(({ GlobalAppSettings: GAS }: any) => <GAS />);

export const Route = createFileRoute('/_secured/administration/account/app')({
  component: GlobalAppSettingsLayout,
});
